<template>
  <div class="container-fluid">
    <tab></tab>
    <neck ref="neck"></neck>
    
    <div class="hidden-xs hidden-sm">
      <div class="web-index-middle">
        <div class="web-middle-center middle" v-if="pageInfo&&pageInfo.page">
          <img :src="global.urlInfo.queryUrl+'/storage/'+pageInfo.page.pic_zh" alt="#" class="web-center-img"/>

          <div class="web-center-center">
            <div class="center-center-view">
              <div class="center-view-title">{{type==1?pageInfo.page.title_zh:pageInfo.page.title}}</div>
              <div class="center-view-font" v-html="type==1?pageInfo.page.description_zh:pageInfo.page.description"></div>
              <!-- <div class="center-view-font">中国生物多样性保护与绿色发展基金会（简称绿发会）良食基金是绿发会旗下关注食物与健康、可持续发展的公益基金，旨在推动良食促进人类健康、动物健康、星球健康。2021年6月，良食基金正式成为蔬适周一的中国官方合作伙伴。蔬适周一希望通过关注人与自然和谐的个人、餐厅、食品加工企业、酒店、地产物业、各教育机构、科研机构和社区等所有利益相关方的协作，在2030年达到增加30%高质量的多样的植物性饮食的目标，实现人类、动物与地球健康和谐共生的愿景。</div>
              <div class="center-view-font start">联系我们：<div class="view-font-label">monday@goodfoodchina.net</div></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-middle" v-if="pageInfo&&pageInfo.page">
        <img :src="global.urlInfo.queryUrl+'/storage/'+pageInfo.page.pic_zh" alt="#" class="phone-middle-top"/>
        <div class="phone-middle-center">
          <div class="phone-view-title">{{type==1?pageInfo.page.title_zh:pageInfo.page.title}}</div>
              <div class="phone-view-font" v-html="type==1?pageInfo.page.description_zh:pageInfo.page.description"></div>
              <!-- <div class="phone-view-font">中国生物多样性保护与绿色发展基金会（简称绿发会）良食基金是绿发会旗下关注食物与健康、可持续发展的公益基金，旨在推动良食促进人类健康、动物健康、星球健康。2021年6月，良食基金正式成为蔬适周一的中国官方合作伙伴。蔬适周一希望通过关注人与自然和谐的个人、餐厅、食品加工企业、酒店、地产物业、各教育机构、科研机构和社区等所有利益相关方的协作，在2030年达到增加30%高质量的多样的植物性饮食的目标，实现人类、动物与地球健康和谐共生的愿景。</div>
              <div class="phone-view-font start">联系我们：<div class="view-font-label">monday@goodfoodchina.net</div></div> -->
        </div>
      </div>
    </div>

    <div class="hidden-xs hidden-sm">
      <div class="web-index-body">
        <video :src="global.urlInfo.queryUrl+'/storage/'+pageTips.brand_video" controls="controls" width="100%" style="width:100%;">您的浏览器不支持播放该视频！</video>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-body">
        <video :src="global.urlInfo.queryUrl+'/storage/'+pageTips.brand_video" controls="controls" width="100%" style="width:100%;">您的浏览器不支持播放该视频！</video>
      </div>
    </div>

    <div class="hidden-xs hidden-sm">
      <div class="web-index-leg spaceBetween">
        <div class="index-leg-list">
          <img src="@/images/listBg1.png" alt="#" class="leg-list-img"/>
          <div class="leg-list-center">
            <div class="list-center-view">
              <div class="center-view-title">{{type==1?block14.title_zh:block14.title}}</div>
              <div class="center-view-tips" v-html="type==1?block14.content_zh:block14.content"></div>
              <!-- <div class="center-view-tips">对你的身体好，对地球也好。加入蔬适周一，</div>
              <div class="center-view-tips">你还可以获得丰富的植物性饮食食谱、指南和资源。现在就加入吧！</div> -->
              <!-- <div class="center-view-list spaceBetween">
                <div class="view-list-li">
                  <div class="list-li-center start">
                    <img src="@/images/icon1.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" placeholder="姓名(必填)" v-model="user_name"/>
                  </div>
                </div>

                <div class="view-list-li">
                  <div class="list-li-center start">
                    <img src="@/images/icon2.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" placeholder="省份（必填）" v-model="mobile_phone"/>
                  </div>
                </div>
              </div> -->

              <div class="center-view-list spaceBetween">
                <div class="view-list-li" style="width:100%;">
                  <div class="list-li-center start">
                    <img src="@/images/icon7.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" :placeholder="type==1?'姓名(必填)':'Name(Required)'" v-model="fromInfo.user_name"/>
                  </div>
                </div>
              </div>
              <div class="center-view-list spaceBetween">
                <div class="view-list-li" style="width:100%;">
                  <div class="list-li-center start">
                    <img src="@/images/icon7.png" alt="#" class="li-center-img"/>
                    <select name="interest" class="li-center-input" id="interest" v-model="fromInfo.provinceid" :style="!fromInfo.provinceid?'color:#708d4b':''">
                      <option disabled value="" hidden>{{type==1?'省份（必填）':'Province(Required)'}}</option>
                      <option :value="item.id" v-for="(item,index) in provinceList" :key="index">{{type==1?item.province:item.province}}</option>
                    </select> 
                  </div>
                </div>
              </div>

              <!-- <div class="center-view-list spaceBetween">
                <div class="view-list-li">
                  <div class="list-li-center start">
                    <img src="@/images/icon3.png" alt="#" class="li-center-img"/>
                    <select name="interest" id="interest" class="li-center-input" v-model="interest" style="width:100%;border:none;">
                            <option value="0">最关心的内容</option>
                            <option value="1">健康饮食</option>
                            <option value="2">员工身心健康</option>
                            <option value="3">健康照护</option>
                            <option value="4">烹饪</option>
                            <option value="5">碳中和</option>
                            <option value="6">企业社会责任</option>
                        </select>
                  </div>
                </div>

                <div class="view-list-li">
                  <div class="list-li-center start">
                    <img src="@/images/icon4.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" placeholder="所属行业" v-model="industry"/>
                  </div>
                </div>
              </div>

              <div class="center-view-list spaceBetween">
                <div class="view-list-li">
                  <div class="list-li-center start">
                    <img src="@/images/icon5.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" placeholder="工作单位" v-model="organization"/>
                  </div>
                </div>

                <div class="view-list-li">
                  <div class="list-li-center start">
                    <img src="@/images/icon6.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" placeholder="职位" v-model="title"/>
                  </div>
                </div>
              </div> -->

              <div class="center-view-list spaceBetween">
                <div class="view-list-li" style="width:100%;">
                  <div class="list-li-center start">
                    <img src="@/images/icon7.png" alt="#" class="li-center-img"/>
                    <input type="text" class="li-center-input" :placeholder="type==1?'邮箱（选填）':'Email(optional)'" v-model="fromInfo.email"/>
                  </div>
                </div>
              </div>

              <div class="center-view-bottom middle">
                <div class="view-bottom-bnt" @click="JoinMonday">{{type==1?'立即加入':'Join Now'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="index-leg-list">
          <img src="@/images/listBg2.png" alt="#" class="leg-list-img"/>
          <div class="leg-list-center">
            <div class="list-center-view">
              <div class="center-view-title view-font-label">{{type==1?block15.title_zh:block15.title}}</div>
              <div class="center-view-tips" v-html="type==1?block15.content_zh:block15.content"></div>
              <!-- <div class="center-view-tips">让所有热爱生活、关注自然和谐的大众和组织机构能够以简单、便捷的方式加入，</div>
              <div class="center-view-tips">共建我们的美好家园。如果你希望获得蔬适周一认证，现在就来申请吧！</div> -->
              <div class="center-right-bottom middle mt1">
                <div class="view-right-bnt bg5"><a href="http://lxi.me/ryn0v" target="_blank">{{type==1?'企业/组织申请':'Enterprise or Organization'}}</a></div>
              </div>
              <div class="center-right-bottom middle mt1">
                <div class="view-right-bnt bg6"><a href="http://lxi.me/7pfsk" target="_blank">{{type==1?'媒体达人申请':'Media'}}</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-leg">
        <div class="phone-leg-list" v-if="type==1">
          <img src="@/images/listBg1.png" alt="#" class="leg-list-img"/>
          <div class="leg-list-center">
            <div class="list-center-view">
              <div class="center-view-titlePhone">{{type==1?block14.title_zh:block14.title}}</div>
              <div class="center-view-tipsPhone" v-html="type==1?block14.content_zh:block14.content"></div>
              <!-- <div class="center-view-tipsPhone">对你的身体好，对地球也好。加入蔬适周一，</div>
              <div class="center-view-tipsPhone">你还可以获得丰富的植物性饮食食谱、指南和资源。现在就加入吧！</div> -->
              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon1.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" :placeholder="type==1?'姓名(必填)':'Name(Required)'" v-model="fromInfo.user_name"/>
                </div>
              </div>

              <!-- <div class="view-list-liPhone" style="width:100%;display:none">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon2.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" placeholder="联系电话" v-model="mobile_phone"/>
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon3.png" alt="#" class="li-center-imgPhone"/>
                  <select name="interest" id="interest" v-model="interest">
                            <option value="0">最关心的内容</option>
                            <option value="1">健康饮食</option>
                            <option value="2">员工身心健康</option>
                            <option value="3">健康照护</option>
                            <option value="4">烹饪</option>
                            <option value="5">碳中和</option>
                            <option value="6">企业社会责任</option>
                        </select>
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon4.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" placeholder="所属行业" v-model="industry"/>
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon5.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" placeholder="工作单位" v-model="organization"/>
                </div>
              </div>  -->

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon6.png" alt="#" class="li-center-imgPhone"/>
                  <select name="interest" id="interest" v-model="fromInfo.provinceid" :style="!fromInfo.provinceid?'color:#708d4b':''">
                    <option disabled value="" hidden>{{type==1?'省份（必填）':'Province(Required)'}}</option>
                    <option :value="item.id" v-for="(item,index) in provinceList" :key="index">{{type==1?item.province:item.province}}</option>
                  </select> 
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon7.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" :placeholder="type==1?'邮箱（选填）':'Email(optional)'" v-model="fromInfo.email"/>
                </div>
              </div>

              <div class="center-view-bottomPhone middle">
                <div class="view-bottom-bntPhone" @click="JoinMonday">{{type==1?'立即加入':'Join now'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="phone-leg-list" v-if="type==2" style="height:12rem">
          <img src="@/images/listBg1.png" alt="#" class="leg-list-img"/>
          <div class="leg-list-center">
            <div class="list-center-view">
              <div class="center-view-titlePhone">{{type==1?block14.title_zh:block14.title}}</div>
              <div class="center-view-tipsPhone" v-html="type==1?block14.content_zh:block14.content"></div>
              <!-- <div class="center-view-tipsPhone">对你的身体好，对地球也好。加入蔬适周一，</div>
              <div class="center-view-tipsPhone">你还可以获得丰富的植物性饮食食谱、指南和资源。现在就加入吧！</div> -->
              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon1.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" :placeholder="type==1?'姓名(必填)':'Name(Required)'" v-model="fromInfo.user_name"/>
                </div>
              </div>

              <!-- <div class="view-list-liPhone" style="width:100%;display:none">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon2.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" placeholder="联系电话" v-model="mobile_phone"/>
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon3.png" alt="#" class="li-center-imgPhone"/>
                  <select name="interest" id="interest" v-model="interest">
                            <option value="0">最关心的内容</option>
                            <option value="1">健康饮食</option>
                            <option value="2">员工身心健康</option>
                            <option value="3">健康照护</option>
                            <option value="4">烹饪</option>
                            <option value="5">碳中和</option>
                            <option value="6">企业社会责任</option>
                        </select>
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon4.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" placeholder="所属行业" v-model="industry"/>
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon5.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" placeholder="工作单位" v-model="organization"/>
                </div>
              </div>  -->

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon6.png" alt="#" class="li-center-imgPhone"/>
                  <select name="interest" id="interest" v-model="fromInfo.provinceid" :style="!fromInfo.provinceid?'color:#708d4b':''">
                    <option disabled value="" hidden>{{type==1?'省份（必填）':'Province(Required)'}}</option>
                    <option :value="item.id" v-for="(item,index) in provinceList" :key="index">{{type==1?item.province:item.province}}</option>
                  </select> 
                </div>
              </div>

              <div class="view-list-liPhone" style="width:100%;">
                <div class="list-li-centerPhone start">
                  <img src="@/images/icon7.png" alt="#" class="li-center-imgPhone"/>
                  <input type="text" class="li-center-inputPhone" :placeholder="type==1?'邮箱（选填）':'Email(optional)'" v-model="fromInfo.email"/>
                </div>
              </div>

              <div class="center-view-bottomPhone middle">
                <div class="view-bottom-bntPhone" @click="JoinMonday">{{type==1?'立即加入':'Join now'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="phone-leg-list" v-if="type==1">
          <img src="@/images/listBg2.png" alt="#" class="leg-list-img"/>
          <div class="leg-list-center">
            <div class="list-center-view">
              <div class="center-view-titlePhone view-font-label">{{type==1?block15.title_zh:block15.title}}</div>
              <div class="center-view-tipsPhone" v-html="type==1?block15.content_zh:block15.content"></div>
              <!-- <div class="center-view-tipsPhone">让所有热爱生活、关注自然和谐的大众和组织机构能够以简单、便捷的方式加入，</div>
              <div class="center-view-tipsPhone">共建我们的美好家园。如果你希望获得蔬适周一认证，现在就来申请吧！</div> -->
              <div class="center-right-bottomPhone middle mt1">
                <div class="view-right-bntPhone bg5"><a href="http://lxi.me/ryn0v" target="_blank">{{type==1?'企业/组织申请':'Enterprise or Organization'}}</a></div>
              </div>
              <div class="center-right-bottomPhone middle mt1">
                <div class="view-right-bntPhone bg6"><a href="http://lxi.me/7pfsk" target="_blank">{{type==1?'媒体达人申请':'Media'}}</a></div>
              </div>
            </div>
          </div>
        </div>
        <div class="phone-leg-list" v-if="type==2" style="height:12rem">
          <img src="@/images/listBg2.png" alt="#" class="leg-list-img"/>
          <div class="leg-list-center">
            <div class="list-center-view">
              <div class="center-view-titlePhone view-font-label">{{type==1?block15.title_zh:block15.title}}</div>
              <div class="center-view-tipsPhone" v-html="type==1?block15.content_zh:block15.content"></div>
              <!-- <div class="center-view-tipsPhone">让所有热爱生活、关注自然和谐的大众和组织机构能够以简单、便捷的方式加入，</div>
              <div class="center-view-tipsPhone">共建我们的美好家园。如果你希望获得蔬适周一认证，现在就来申请吧！</div> -->
              <div class="center-right-bottomPhone middle mt1">
                <div class="view-right-bntPhone bg5"><a href="http://lxi.me/ryn0v" target="_blank">{{type==1?'企业/组织申请':'Enterprise or Organization'}}</a></div>
              </div>
              <div class="center-right-bottomPhone middle mt1">
                <div class="view-right-bntPhone bg6"><a href="http://lxi.me/7pfsk" target="_blank">{{type==1?'媒体达人申请':'Media'}}</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-xs hidden-sm">
      <div class="web-index-foot">
        <div class="index-foot-title middle">{{type==1?'热门新闻':'Hot news'}}</div>

        <div class="index-foot-center start">
          <div class="foot-center-li" @click="windowOpen(item.url_type,item.url,item.id)" v-for="(item,index) in pageInfo.recommend_news" :key="index">
            <div class="center-li-top">
              <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/dietary">{{type==1?item.category.category_name_zh:item.category.category_name}}</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">{{item.start_time}}</div>
              <div class="li-center-title fontHidden">{{type==1?item.title_zh:item.title}}</div>
              <div class="li-center-font">{{type==1?item.summary_zh:item.summary}}</div>
            </div>
          </div>
          <!-- <div class="foot-center-li" @click="windowOpen('https://mp.weixin.qq.com/s/au3YrAS_X94rtxhFx94kdw')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040531.png" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/campaign">蔬适活动</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.20</div>
              <div class="li-center-title fontHidden">蔬适周一x阿军轻蔬全国巡演杭州站</div>
              <div class="li-center-font">2021年7月17日，蔬适周一和阿军轻蔬全国巡演来到人间天堂杭州，与80多位朋友相聚梅龙草堂，品味轻蔬，交流健康...</div>
            </div>
          </div>
          <div class="foot-center-li" @click="windowOpen('https://shimo.im/docs/QRJHrPJ33HvTyTJw/ 《（CH/EN）蔬适周一认证计划 》')">
            <div class="center-li-top">
              <img src="/news/default.jpg" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/solution">蔬适方案</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.22</div>
              <div class="li-center-title fontHidden">【认证】蔬适周一认证计划2021</div>
              <div class="li-center-font">“蔬适周一”是一个全球性的倡议，鼓励人们增加植物性饮食，以促进个人和地球的健康和谐发展。这项倡议由...</div>
            </div>
          </div>
          <div class="foot-center-li" @click="windowOpen('https://mp.weixin.qq.com/s/tZQ9Fh5FxySgJZkr8gV2bg')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040326.png" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/partner">蔬适机构</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.22</div>
              <div class="li-center-title fontHidden">蔬适周一中国首批10家授牌机构</div>
              <div class="li-center-font">2021年5月22日，蔬适周一中国区10家首批授牌机构在第六期“联合国粮食系统峰会·中国说”对话上，领取了具有...</div>
            </div>
          </div> -->
        </div>

        <!-- <div class="index-foot-bottom middle">
          <div class="foot-bottom-btn">更多新闻</div>
        </div> -->
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-foot">
        <div class="index-foot-titlePhone middle">{{type==1?'热门新闻':'Hot news'}}</div>

        <div class="index-foot-center spaceBetween wrap">
          <div class="foot-center-liPhone" @click="windowOpen(item.url_type,item.url,item.id)" v-for="(item,index) in pageInfo.recommend_news" :key="index">
            <div class="center-li-top">
              <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/dietary">{{type==1?item.category.category_name_zh:item.category.category_name}}</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">{{item.start_time}}</div>
              <div class="li-center-title fontHidden">{{type==1?item.title_zh:item.title}}</div>
              <div class="li-center-font">{{type==1?item.summary_zh:item.summary}}</div>
            </div>
          </div>
          <!-- <div class="foot-center-liPhone" @click="windowOpen('https://mp.weixin.qq.com/s/au3YrAS_X94rtxhFx94kdw')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040531.png" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/campaign">蔬适活动</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.20</div>
              <div class="li-center-title fontHidden">蔬适周一x阿军轻蔬全国巡演杭州站</div>
              <div class="li-center-font">2021年7月17日，蔬适周一和阿军轻蔬全国巡演来到人间天堂杭州，与80多位朋友相聚梅龙草堂，品味轻蔬，交流健康...</div>
            </div>
          </div>
          <div class="foot-center-liPhone" @click="windowOpen('https://shimo.im/docs/QRJHrPJ33HvTyTJw/ 《（CH/EN）蔬适周一认证计划 》')">
            <div class="center-li-top">
              <img src="/news/default.jpg" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/solution">蔬适方案</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.22</div>
              <div class="li-center-title fontHidden">【认证】蔬适周一认证计划2021</div>
              <div class="li-center-font">“蔬适周一”是一个全球性的倡议，鼓励人们增加植物性饮食，以促进个人和地球的健康和谐发展。这项倡议由...</div>
            </div>
          </div>
          <div class="foot-center-liPhone" @click="windowOpen('https://mp.weixin.qq.com/s/tZQ9Fh5FxySgJZkr8gV2bg')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040326.png" alt="#" class="center-li-img"/>
              <div class="li-top-center"><a target="/partner">蔬适机构</a></div>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.22</div>
              <div class="li-center-title fontHidden">蔬适周一中国首批10家授牌机构</div>
              <div class="li-center-font">2021年5月22日，蔬适周一中国区10家首批授牌机构在第六期“联合国粮食系统峰会·中国说”对话上，领取了具有...</div>
            </div>
          </div> -->
        </div>

        <!-- <div class="index-foot-bottomPhone middle">
          <div class="foot-bottom-btnPhone">更多新闻</div>
        </div> -->
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab.vue'
import neck from '@/components/neck.vue'
import footerBar from '@/components/footerBar.vue'
import axios from 'axios'
import {format} from '@/utils/util.js'
export default {
  name: 'Home',
  components: {
    tab:tab,
    footerBar:footerBar,
    neck:neck
  },
  data () {
    return {
      fromInfo:{
        user_name:'',
        email:'',
        provinceid:''
      },
      provinceList:[],
      pageInfo:{},
      pageTips:{},
      block14:{},
      block15:{},
      type:1
    }
  },
  methods:{
    JoinMonday(){
      const vm=this
      if(!vm.fromInfo.user_name){
        layer.msg('请输入您的姓名！',{time: 2000});
        return
      }
      if(!vm.fromInfo.provinceid){
        layer.msg('请输入您的省份！',{time: 2000});
        return
      }
      // if(!vm.fromInfo.email){
      //   layer.msg('请输入您的邮箱地址！',{time: 2000});
      //   return
      // }
      axios.post(`${vm.global.urlInfo.queryUrl}/api/monday/save_monday`,vm.fromInfo).then(data=>{
        if(data&&data.data&&data.data.code==1){
          layer.open({
            type: 1,
            title:'感谢你的支持',
            area: '800px',
            offset: '50px',
            content: `<img src='${vm.global.urlInfo.queryUrl}/storage/${data.data.data}' style="width:800px;">`,
            btn: ['确认'],
            yes: function(index, layero){
              layer.close(index)
            }
          });
        }else{
          layer.msg(data.data.message,{time: 2000});
        }
      })    
    },
    windowOpen(url_type,url,id){
      const vm=this
      if(url_type==0){
        vm.$router.push({path: '/news',query:{id:id}});
        //window.open('/news/'+id);
      }else{
        window.open(url);
      }      
    },
    queryProvinceList(){
      const vm=this
      axios.get(`${vm.global.urlInfo.queryUrl}/api/monday/province_list`).then(data=>{
        if(data&&data.data&&data.data.code==1){
          vm.provinceList = data.data.data
        }
      })
    },
    queryIndex(){
      const vm=this
      axios.get(`${vm.global.urlInfo.queryUrl}/api/monday/index`).then(data=>{
        if(data&&data.data&&data.data.code==1){
          data.data.data.recommend_news.forEach(da=>{
            da.start_time=format(new Date(da.start_time),'YYYY.MM.DD')
            da.summary_zh = da.summary_zh&&da.summary_zh.length>32?da.summary_zh.slice(0,32)+'...':da.summary_zh
            da.summary = da.summary&&da.summary.length>32?da.summary.slice(0,32)+'...':da.summary
          })
          vm.pageInfo = data.data.data
        }
      })
    },
    querySettings(){
      const vm=this
      axios.get(`${vm.global.urlInfo.queryUrl}/api/monday/settings`).then(data=>{
        if(data&&data.data&&data.data.code==1){
          document.title = data.data.data.site_name
          vm.pageTips = data.data.data
          vm.$refs.neck.setPageTips(vm.pageTips)
        }
      })
    },
    queryBlock14(){
      const vm=this
      axios.get(`${vm.global.urlInfo.queryUrl}/api/monday/block/14`).then(data=>{
        if(data&&data.data&&data.data.code==1){
          vm.block14 = data.data.data
          console.log(vm.block14)
        }
      })
    },
    queryBlock15(){
      const vm=this
      axios.get(`${vm.global.urlInfo.queryUrl}/api/monday/block/15`).then(data=>{
        if(data&&data.data&&data.data.code==1){
          vm.block15 = data.data.data
          console.log(vm.block15)
        }
      })
    },
    choiceType(num){
      const vm=this
      vm.type = localStorage.getItem('ssType') || Number(num)
      vm.$refs.neck.setType(vm.type,0)
      vm.$refs.footerView.setType(vm.type)
    }
  },
  created () {
    
  },
  mounted(){
    const vm=this
    vm.choiceType(1)
    vm.querySettings()
    vm.queryProvinceList()
    vm.queryIndex()
    vm.queryBlock14()
    vm.queryBlock15()
  }
}
</script>
<style scoped>
.container-fluid{
  width: 100%;
  padding: 0;
  margin: 0;
}

/**  首页  项目介绍  **/
.web-index-middle{
  padding: 0.75rem 0.5rem 0.625rem;
  height: auto;
  background: #f5f8ef;
}
.web-middle-center{
  width: 100%;
  height: 3.75rem;
  background: #fff;
  border-radius: 10px;
}
.web-center-img{
  height: 3.75rem;
  width: auto;
  border-radius: 10px 0 0 10px;
}
.web-center-center{
  border-radius: 0 10px 10px 0;
  height: 3.75rem;
  flex: 2;
}
.center-center-view{
  padding: 0.375rem 0.625rem;
  height: 100%;
  overflow: hidden;
}
.center-view-title{
  font-size: 0.225rem;
  color: #365b3a;
  width: 100%;
  text-align: left;
  line-height: 1;
  margin-bottom: 0.2875rem;
  font-family: 'huangyou';
}
.center-view-font{
  font-size: 0.1rem;
  color: #59625a;
  line-height: 2;
  text-align: left;
  margin-bottom: 0.25rem;
  letter-spacing: 2px;
}

/**  首页  项目介绍 phone  **/
.phone-index-middle{
  padding: 1rem 0.4rem;
  height: auto;
  background: #f5f8ef;
}
.phone-middle-top{
  width: 100%;
  height: auto;
  border-radius: 10px 10px 0 0;
}
.phone-middle-center{
  padding: 0.8rem 0.6rem;
  height: auto;
  background: #fff;
  border-radius: 0 0 10px 10px;
}
.phone-center-view{
  padding: 0.375rem 0.625rem;
  height: 100%;
  overflow: hidden;
  
}
.phone-view-title{
  font-size: 0.52rem;
  color: #365b3a;
  width: 100%;
  text-align: left;
  line-height: 1;
  margin-bottom: 0.2875rem;
}
.phone-view-font{
  font-size: 0.32rem;
  color: #59625a;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 0.25rem;
  letter-spacing: 2px;
}

/**  首页  视频  **/
.web-index-body{
  width: 100%;
  height: 5.625rem;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
}
.index-body-img{
  width: 100%;
  height: 100%;
  display: inline-block;
  line-height: 0;
}

/**  首页  视频  phone  **/
.phone-index-body{
  width: 100%;
  height: auto;
}
.phone-body-img{
  width: 100%;
  height: auto;
}


/**  首页  申请  **/
.web-index-leg{
  padding: 0.625rem 0.5rem 0.25rem;
  height: auto;
  background: #f5f8ef;
}
.index-leg-list{
  width: 49%;
  height: 3.75rem;
  border-radius: 12px;
  background: #fff;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
}
.leg-list-img{
  width: 100%;
  height: 100%;
  display: inline-block;
  line-height: 0;
}
.leg-list-center{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.list-center-view{
  padding: 0.225rem 0.25rem 0.375rem;
  height: 100%;
}
.center-view-title{
  width: 100%;
  height: auto;
  line-height: 1;
  font-size: 0.225rem;
  color: #708d4b;
  /* font-weight: 600; */
  text-align: center;
  margin-bottom: 0.25rem;
  font-family:'huangyou';
}
.center-view-tips{
  font-size: 0.1rem;
  color: #5a625a;
  line-height: 2;
  text-align: center;
  margin-bottom: 0.1rem;
}
.center-view-list{
  width: 100%;
  height: auto;
  padding-top: 0.125rem;
  
}
.view-list-li{
  width: 48%;
  height: 0.3125rem;
  border: 1px solid #bfc4b8;
  border-radius: 6px;
  background: #fff;
}
.list-li-center{
  padding: 0 0.125rem;
  height: 0.3125rem;
}
.li-center-img{
  width: auto;
  height: 0.15rem;
}
.li-center-input{
  flex: 2;
  height: auto;
  margin-left: 0.125rem;
  font-size: 0.1125rem;
  color: #365b3a;
  border: none;
  background: none;
}
input::placeholder{
  font-size: 0.1125rem;
  color: #779253;
}
.center-view-bottom,.center-right-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.125rem;
}
.view-bottom-bnt{
  width: 1.25rem;
  height: 0.3125rem;
  background: #708d4b;
  border-radius: 0.3125rem;
  font-size: 0.125rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 0.3125rem;
  cursor: pointer;
}
.view-right-bnt{
  height: 0.5rem;
  width: 2.5rem;
  background: #708d4b;
  border-radius: 0.5rem;
  font-size: 0.15rem;
  color: #fff;
  font-weight: 600;
  letter-spacing: 1px;
  text-align: center;
  line-height: 0.5rem;
  cursor: pointer;
}
.view-right-bnt a{color:white}

/**  首页  申请  phone  **/
.phone-index-leg{
  padding: 0.8rem 0.2rem;
  height: auto;
  background: #f5f8ef;
}
.phone-leg-list{
  width: 100%;
  height: 8.8rem;
  margin-bottom: 0.32rem;
  border-radius: 12px;
  background: #fff;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
}
.center-view-titlePhone{
  width: 100%;
  height: auto;
  line-height: 1;
  font-size: 0.52rem;
  color: #708d4b;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.25rem;
  padding-top: 0.25rem;
}
.center-view-tipsPhone{
  font-size: 0.32rem;
  color: #5a625a;
  line-height: 2;
  text-align: center;
  margin-bottom: 0.2rem;
}
.list-li-centerPhone{
  padding: 0 0.25rem;
  height: 100%;
}
.view-list-liPhone{
  width: 100%;
  height: 1rem;
  margin-bottom: 0.4rem;
  border: 1px solid #bfc4b8;
  border-radius: 6px;
  background: #fff;
}
.li-center-imgPhone{
  width: auto;
  height: 0.6rem;
}
.li-center-inputPhone{
  flex: 2;
  height: auto;
  margin-left: 0.25rem;
  font-size: 0.48rem;
  color: #365b3a;
  border: none;
  background: none;
}
.li-center-inputPhone::placeholder{
  font-size: 0.48rem;
  color: #779253;
}
.center-view-bottomPhone{
  width: 100%;
  height: auto;
  margin-top: 0.4rem;
}
.view-bottom-bntPhone{
  height: 0.8rem;
  width: 2.8rem;
  background: #708d4b;
  border-radius: 0.5rem;
  font-size: 0.35rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 0.8rem;
}
.center-right-bottomPhone{
  width: 100%;
  height: auto;
  padding-top: 0.4rem;
}
.view-right-bntPhone{
  height: 1rem;
  width: 5.6rem;
  background: #708d4b;
  border-radius: 1rem;
  font-size: 0.35rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  line-height: 1rem;
}
.view-right-bntPhone a{color:white}
/**  首页  新闻  **/
.web-index-foot{
  padding: 0.35rem 0.5rem 0.15rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-title{
  font-size: 0.3rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
  font-family:'huangyou';
}
.index-foot-center{
  width: 100%;
  height: auto;
}
.foot-center-li{
  width: 2.075rem;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  margin-right: 12px;
}
.foot-center-li:last-child{
  margin-right: 0;
}
.center-li-top{
  width: auto;
  height: auto;
  position: relative;
}
.center-li-img{
  width: 100%;
  height: auto;
  max-height: 1.556rem;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}
.li-top-center{
  padding: 0.0625rem 0.1rem;
  font-size: 0.1125rem;
  color: #fff;
  line-height: 1;
  background: #e4a169;
  position: absolute;
  top: 0;
  left: 0.1875rem;
  border-radius: 0 0 6px 6px;
  
}
.li-top-center a {color:white}
.center-li-center{
  height: auto;
  padding: 0.125rem 0.1625rem 0.2125rem;
  background: #fff;
  border-radius: 0 0 8px 8px;
}
.li-center-label{
  font-size: 0.0935rem;
  color: #728b4a;
  line-height: 1;
  margin-bottom: 0.125rem;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.li-center-title{
  font-size: 0.1125rem;
  color: #365b3a;
  font-weight: 600;
  text-align: left;
  letter-spacing: 2px;
  line-height: 1.5;
  margin-bottom: 0.1375rem;
  font-family: "Times New Roman", Times, serif;
}
.li-center-font{
  font-size: 0.0935rem;
  color: #5a625a;
  line-height: 1.6;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.index-foot-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.25rem;
  padding-bottom: 0.375rem;
}
.foot-bottom-btn{
  width: 1rem;
  height: 0.25rem;
  border: 1px solid #365b3a;
  border-radius: 0.25rem;
  color: #365b3a;
  font-size: 0.1125rem;
  line-height: 0.25rem;
  font-family: "Times New Roman", Times, serif;
  cursor: pointer;
}
.index-foot-bottomPhone{
  width: 100%;
  height: auto;
  padding-top: 0.25rem;
}

/**  首页  新闻 phone  **/
.phone-index-foot{
  padding: 0rem 0.2rem 0.6rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-titlePhone{
  font-size: 0.52rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
}
.foot-center-liPhone{
  width: 48%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 0.32rem;
}
.foot-bottom-btnPhone{
  width: 2.6rem;
  height: 0.6rem;
  border: 1px solid #365b3a;
  border-radius: 0.6rem;
  color: #365b3a;
  font-size: 0.32rem;
  line-height: 0.6rem;
  font-family: "Times New Roman", Times, serif;
}

.phone-center-list{
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  font-size: 0.36rem;
  color: #fff;
  line-height: 1.4;
  letter-spacing: 2px;
  background: rgba(220,155,97,0.95);
}

.view-font-label{
  color: #e4a169;
}
.bg1{
  background: rgba(112,141,75,0.95);
}
.bg2{
  background: rgba(191,107,87,0.95);
}
.bg3{
  background: rgba(54,91,58,0.95);
}
.bg4{
  background: rgba(146,152,67,0.95);
}
.bg5{
  background: #e4a169;
} 
.bg6{
  background: #e4bd69;
}
.mt1{
  margin-top: 0.125rem;
}
</style>

